// eslint-disable-next-line import/no-cycle
import { BaseFieldConfig, ComponentNameEnum, ResponsiveDisplayStackEnum } from '@/types';

const getResponsiveDisplayFieldConfig = (property = '', defaultValue = ''): BaseFieldConfig => ({
  componentName: ComponentNameEnum.BUTTON_GROUP,
  options: {
    [ResponsiveDisplayStackEnum.LTR]: {
      title: 'templateBuilder.fields.stackLtr',
      iconClass: 'fa-sharp fa-solid fa-code-pull-request fa-rotate-180',
      property,
      defaultValue,
    },
    [ResponsiveDisplayStackEnum.RTL]: {
      title: 'templateBuilder.fields.stackRtl',
      iconClass: 'fa-sharp fa-solid fa-code-pull-request fa-flip-vertical',
      property,
      defaultValue,
    },
    [ResponsiveDisplayStackEnum.NO_STACK]: {
      title: 'templateBuilder.fields.noStack',
      iconClass: 'fa-sharp fa-solid fa-ellipsis-stroke',
      property,
      defaultValue,
    },
  },
});
export default getResponsiveDisplayFieldConfig;
